import { render, staticRenderFns } from "./requisitarConsulta-semcf.vue?vue&type=template&id=04ae8680"
import script from "./requisitarConsulta-semcf.vue?vue&type=script&lang=js"
export * from "./requisitarConsulta-semcf.vue?vue&type=script&lang=js"
import style0 from "./requisitarConsulta-semcf.vue?vue&type=style&index=0&id=04ae8680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports